export const validateArray = (value) => {
	return value || [];
};
